const SPECIAL_TAGS = {
  'Highest rated': {
    label: 'Highest rated',
    tooltip: 'Based on overall user ratings.',
  },
  'Free version': {
    label: 'Highly rated for Free version',
    tooltip: 'Based on user reviews about the free product version',
  },
}

const getTagInfo = (tag, { skipSpecial = false } = {}) => {
  if (!tag) return null

  if (skipSpecial) {
    return {
      label: tag,
    }
  }
  return (
    SPECIAL_TAGS[tag] || {
      label: tag,
      tooltip: 'Based on user ratings for the mentioned feature.',
    }
  )
}

export { getTagInfo, SPECIAL_TAGS }
